import { useEffect } from "react";
import { useAnimation } from "../hooks/useAnimation";

const Contact = () => {
    const animate = useAnimation()

    useEffect(() => {
        animate()
        window.scrollTo(0, 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="contact-ctr d-flex justify-content-center flex-column align-items-center">
            <div className="w-100 d-flex flex-column justify-content-center align-items-center">
                <div className="page-banner w-100 d-flex justify-content-center align-items-center"  >
                    <div
                        className="page-container p-0 d-flex flex-column flex-lg-row justify-content-between align-items-center align-items-lg-center">
                        <div className="page-banner__card" data-animation="slideInRight">
                            <h1 className="page-banner__card-title mb-4">
                                Bize Ulaşın
                            </h1>

                            <p className="page-banner__card-text mt-3">
                                Türkiye'nin 9 ilinde 11 operasyon merkeziyle sizelere en hızlı ve güvenilir hizmeti vermeye genişleyen ağımızla devam ediyoruz.
                            </p>
                        </div>

                        <div className="page-banner__image mt-5 mt-lg-0" data-animation="slideInLeft">
                            <img src="/images/contact-banner.png" alt="" />
                        </div>
                    </div>
                </div>

                <div className="contact-inner page-container w-100">
                    <div className="contact-cards w-100">
                
                        <div data-animation="zoomIn" data-animation-delay="50ms"
                            className="contact-cards__item d-flex flex-column justify-content-between align-items-start">
                            <div className="d-flex flex-column justify-content-start align-items-start">
                                <h5 className="contact-item-title">
                                    İstanbul Seyrantepe Operasyon Merkezi

                                </h5>
                                <p className="contact-item-address">
                                    Seyrantepe Mah. İbrahim Karaoğlanoğlu Cad. No:105F İstanbul/Kağıthane
                                </p>
                                  {/* <a className="contact-item-phone mb-2" href="tel:05317637834">
                                    0850 220 70 90
                                </a> */}
                                <a className="contact-item-email mb-3" href="mailto:kuryeik@fiyuu.com.tr">
                                    kuryeik@fiyuu.com.tr
                                </a>

                            </div>
                            <div className="iframe-area">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3006.616579313059!2d28.993182877429838!3d41.0992233713381!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab681ba7d9497%3A0xd08e4997d3d69eb1!2zU2V5cmFudGVwZSwgxLBicmFoaW0gS2FyYW_En2xhbm_En2x1IENkLiBObzoxMDUsIDM0NDE4IEvDosSfxLF0aGFuZS_EsHN0YW5idWw!5e0!3m2!1sen!2str!4v1712143714364!5m2!1sen!2str"
                                    style={{ border: "0" }} allowFullScreen loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact;
